import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";

/** @jsx $jsx */
import { $jsx } from 'framework7';
import moment from 'moment';
import Base from '../js/base';
import Utils from '../js/utils';
export default (function (props, _ref) {
  var $ = _ref.$,
      $update = _ref.$update,
      $f7 = _ref.$f7,
      $tick = _ref.$tick,
      $el = _ref.$el,
      $f7route = _ref.$f7route;
  var rows;
  var table = 'kho_thoc';
  var id_emp = $f7route.params.id_emp;
  var m = $f7route.params.month + "%";

  _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var rs;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return Base.call({
              method: '_findAll',
              table: table,
              params: {
                fields: 'kho_thoc.*, kho_thoc_mau.mo_ta',
                join: 'JOIN kho_thoc_mau ON kho_thoc.id_mau = kho_thoc_mau.id',
                where: 'kho_thoc.deleted_at IS NULL AND id_emp = :id_emp AND kho_thoc.created_at LIKE :m',
                where_data: {
                  id_emp: id_emp,
                  m: m
                }
              }
            });

          case 2:
            rs = _context.sent;
            rows = rs.rows;
            $update();

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }))();

  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
  <div class="popup popup-khothoc-detail">
    <div class="view">
      <div class="navbar">
        <div class="navbar-bg"></div>
        <div class="navbar-inner">
          <div class="title">Lịch sử góp thóc</div>
          <div class="right">
            <a href="#" class="link popup-close" data-popup=".popup-khothoc-detail"><i class="icon f7-icons">multiply</i></a>
          </div>
        </div>
      </div>
      <div class="page">
        <div class="page-content">

          <div class="card data-table margin-half">
            <table>
              <thead>
                <tr>
                  <th>STT.</th>
                  <th>Lý do</th>
                </tr>
              </thead>
              <tbody>
                ${rows && rows.map((row,index)=>$h`
                  <tr>
                    <td>${index+1}.</td>
                    <td>
                      <div style="margin-bottom: 10px;">${row.mo_ta}</div>
                      <div style="display: flex; justify-content: space-between;">
                        <div>${moment(row.created_at).format('D/M/YYYY HH:mm')}</div>
                        <div>Số thóc: ${row.so_thoc}</div>
                      </div>
                    </td>
                  </tr>
                `)}
              </tbody>
            </table>
          </div>

        </div>
      </div>
    </div>
  </div>
`
    }
    ;
});